if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.initCounter();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    initCounter() {
      const content = this.querySelector('.product-media-modal__content');
      const counter = this.querySelector('.product-media-modal__counter');
      if (!content || !counter) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const currentSpan = counter.querySelector('.product-media-modal__counter-current');
              if (currentSpan && entry.target.dataset.index) {
                currentSpan.textContent = entry.target.dataset.index;
              }
            }
          });
        }, {
          root: content,
          rootMargin: '-20% 0px -40% 0px',
          threshold: 0
        });
      }
    }

    showActiveMedia() {
      const openedMediaId = this.openedBy ? this.openedBy.getAttribute("data-media-id") : null;
      if (!openedMediaId) return;

      this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      );

      const items = this.querySelectorAll('.product-media-modal__item');
      const totalSpan = this.querySelector('.product-media-modal__counter-total');
      const currentSpan = this.querySelector('.product-media-modal__counter-current');
      const counter = this.querySelector('.product-media-modal__counter');

      if (items.length > 1) {
        if (totalSpan) totalSpan.textContent = items.length;
        if (counter) counter.style.display = '';
        items.forEach((item, index) => {
          item.dataset.index = index + 1;
          if (this.observer) this.observer.observe(item);
        });
      } else if (counter) {
        counter.style.display = 'none';
      }

      const activeMedia = this.querySelector(`.product-media-modal__item[data-media-id="${openedMediaId}"]`) || this.querySelector(`[data-media-id="${openedMediaId}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        if (currentSpan && activeMedia.dataset.index) {
          currentSpan.textContent = activeMedia.dataset.index;
        }

        window.requestAnimationFrame(() => {
          activeMedia.scrollIntoView({ behavior: 'auto', block: 'start' });
        });

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.offsetWidth) {
          container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
        }

        const deferredMedia = activeMedia.nodeName === 'DEFERRED-MEDIA' ? activeMedia : activeMedia.querySelector('deferred-media');
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (deferredMedia && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }
    }
  });
}
